import { render, staticRenderFns } from "./air-change.vue?vue&type=template&id=61cc048e&scoped=true&"
import script from "./air-change.vue?vue&type=script&lang=js&"
export * from "./air-change.vue?vue&type=script&lang=js&"
import style0 from "./air-change.vue?vue&type=style&index=0&id=61cc048e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cc048e",
  null
  
)

export default component.exports